/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, h } from './index-ef0fa435.js';

const DebugContent = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.text = undefined;
  }
  render() {
    return [
      h("div", null, h("pre", null, JSON.stringify(this.text, null, 2)))
    ];
  }
};

export { DebugContent as lar_debug_content };

//# sourceMappingURL=lar-debug-content.entry.js.map